import React from 'react';

const WhyBest = () => {
    return (
        <div className="mt-5 pt-5 mb-5 pb-5">
            <section className="mb-5 pb-5">
	  <div className="container">
      <div className="text-center mt-5 pt-5 mb-3">
      <h2 className="orange">Why Tour-X </h2>
      <h1>Why You Are Travel With Tour-X</h1>
    </div>
	    <div className="row text-center" >
	      <div className="col-md-12 col-lg-4 col-sm-12 mx-auto g-4">
	        <div className="pt-2 border shadow p-5"><span>
                <img height="120" src="https://cdn4.iconfinder.com/data/icons/instagram-highlight/64/tour-agent-512.png" alt="" />
            </span>
	          <h3 className="title">2000+ Our worldwide guide</h3>
	        </div>
	      </div>
	      <div className="col-md-12 col-lg-4 col-sm-12 g-4">
	        <div className="pt-2 border shadow p-5"> <span>
                <img height="120" src="https://icon-library.com/images/trust-icon-png/trust-icon-png-5.jpg" alt="" />
            </span>
	          <h3 className="title">100% trusted travel agency</h3>
	          
	        </div>
	      </div>
	      <div className="col-md-12 col-lg-4 col-sm-12 g-4">
	        <div className="pt-2 border shadow p-5"> <span>
                <img height="120" src="https://cdn-icons-png.flaticon.com/512/2798/2798316.png" alt="" />
            </span>
	          <h3 className="title">90% of our traveller happy</h3>
	         
	        </div>
	      </div>
	    </div>
	  </div>
	</section>
        </div>
    );
};

export default WhyBest;